import { setIsUserCriticalAction } from '@wildberries/databus-service-user';
import { mfaValidate } from '@/_utils/init-app-utils/requests-proxy/init-request-proxy-verify/_utils/mfa-validate';
import { getUserDataCriticalActionCode } from './_utils/get-user-data-critical-action-code';

export const criticalAction = async ({
  retryRequest,
  sticker,
  deviceId,
}: {
  retryRequest: any;
  sticker: string;
  deviceId: string;
}) => {
  await getUserDataCriticalActionCode().then((code: number) => {
    mfaValidate({ code, sticker, deviceID: deviceId }).then(() => {
      retryRequest();
      setIsUserCriticalAction(false);
    });
  });
};
